import { render, staticRenderFns } from "./templateS.vue?vue&type=template&id=a050e95c&scoped=true&"
import script from "./templateS.vue?vue&type=script&lang=js&"
export * from "./templateS.vue?vue&type=script&lang=js&"
import style0 from "./templateS.vue?vue&type=style&index=0&id=a050e95c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a050e95c",
  null
  
)

export default component.exports